import React from 'react'
import PropTypes from 'prop-types'
import { convertMdToHtml } from '..'
import Interweave from 'interweave'
import Section from '../../Section'

const CodeCoverage = ({ report: { reportContent } }) => {
  let cleanTable = ''

  const solidityCoverageContent = reportContent.breakdownAndAutomatedAnalysis.codeCoverageOutput

  if (solidityCoverageContent) {
    const formattedSolidityCoverageDescription = convertMdToHtml
      .makeHtml(solidityCoverageContent)
      .replace(/(<p>[-|]+<\/p>)|(<td>[-]+<\/td>)|/g, '')

    const boldDirectory = formattedSolidityCoverageDescription.replace(
      /(?=\w*[/]+)\w+[/]/g,
      "<span classname='directory'>$&</span>",
    )
    const indentFiles = boldDirectory.replace(/([\w]+\.sol)/g, '$&')
    cleanTable = indentFiles
  }

  return (
    <Section title="Code Coverage">
      {reportContent.breakdownAndAutomatedAnalysis.codeCoverageSummary ? (
        <Interweave
          content={convertMdToHtml.makeHtml(
            reportContent.breakdownAndAutomatedAnalysis.codeCoverageSummary,
          )}
        />
      ) : null}
      {solidityCoverageContent ? (
        <div className="coverage-table-container">
          <Interweave content={cleanTable} />
        </div>
      ) : null}
    </Section>
  )
}

CodeCoverage.propTypes = {
  report: PropTypes.object,
}

export default CodeCoverage
